import { emptyFragment } from '@execonline-inc/execonline-ui';
import { asMaybeasy, Maybe } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../../CurrentUserStore';
import { findLink } from '../../../../../LinkyLinky';
import { T } from '../../../../../Translations';
import ExternalLinkSVG from '../../../../Cutesies/ExternalLinkSVG';

interface Props {
  name: string;
  internalName: Maybe<string>;
  id: number;
}

const Names: React.FC<Props> = ({ name, internalName, id }) => (
  <div>
    <h3 className="ml-3 cursor-pointer text-lg font-semibold">
      <_ExternalLinkSVG name={name} id={id} />
    </h3>
    <_InternalName internalName={internalName} />
  </div>
);

const _ExternalLinkSVG = observer(({ name, id }: { name: string; id: number }) =>
  findLink('preview-learning-collection-template', currentUserStore.links)
    .map(() => (
      <Link
        to={`/learning_collections/${id}/preview`}
        target="_blank"
        rel="noopener noreferrer"
        title={`Launch participant preview for ${name}`}
      >
        <div className="flex">
          <div className="mr-6">{name}</div>
          <div className="mt-1.5">
            <ExternalLinkSVG />
          </div>
        </div>
      </Link>
    ))
    .getOrElse(emptyFragment),
);

const _InternalName = observer(({ internalName }: { internalName: Maybe<string> }) =>
  asMaybeasy(internalName)
    .map((internalName) => (
      <div className="ml-3 text-sm text-gray-700">
        <span>
          <T kind="Internal Name:" />
        </span>
        <span className="ml-1">{internalName}</span>
      </div>
    ))
    .getOrElse(emptyFragment),
);

export default observer(Names);
